import {
  VStack,
  Box,
  Flex,
  Text,
  IconButton,
  Stack,
  Collapse,
  Icon,
  Spacer,
  useColorModeValue,
  useDisclosure,
  HStack,
  Grid,
  chakra,
  Link,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon, ChevronDownIcon, } from '@chakra-ui/icons';
import React from 'react';
import { FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { IoLogoInstagram } from "react-icons/io5";
import { ColorModeSwitcher } from '../ColorModeSwitcher';


export default function Navbar() {
  // const { isOpen, onToggle } = useDisclosure();
  const { onToggle, isOpen, onOpen, onClose } = useDisclosure(); //from <Modal/>

  return (
    <Box>
      <Flex
        position={'fixed'}
        w={'full'}
        opacity={0.85}
        bg={useColorModeValue('white', 'gray.800')}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        py={{ base: 6 }}
        px={{ base: 4 }}
        borderBottom={1}
        align={'center'}
        zIndex={'900'}>
        {/* left menu */}

        <Flex flex={{ base: 'auto', md: 'auto' }}
          display={{ base: 'flex', md: 'flex' }}>
          <IconButton
            _hover={{
              color: 'gray.500',
              transform: "scale(0.98)",
              transition: 'all .1s ease',
            }}
            _active={{
              color: 'gray.500',
              transform: "scale(0.96)",
              transition: 'all .1s ease',
            }}

            onClick={onToggle}
            icon={
              isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
            }
            variant={'ghost'} aria-label={'Toggle Navigation'}
          />
          <ColorModeSwitcher justifySelf="flex-end" />
        </Flex>

        {/* logo */}
        <Flex flex={{ base: 'auto' }}>
          <Link href='#'>
            {/* <Logotextual/> */}
            <Text textAlign='center'
              fontSize={{ base: 'medium', md: '3xl' }}
              fontWeight='bold'
              textTransform="uppercase"
              letterSpacing={2}
              color={useColorModeValue('gray.900', 'white')}
            >SHAREL LIU
            </Text>
          </Link>
        </Flex>

        {/* social media */}
        <HStack
          flex={{ base: 1, md: 0 }}
          justify={'flex-end'}
          spacing={6}
          mr={4}
        >
          <Link
            _hover={{
              color: 'gray.500',
              transform: "scale(0.98)",
              transition: 'all .1s ease',
            }}
            _active={{
              color: 'gray.500',
              transform: "scale(0.96)",
              transition: 'all .1s ease',
            }}

            href='https://www.youtube.com/@sharelsj' isExternal
            color={useColorModeValue('gray.900', 'white')}>
            {<FaYoutube />}
          </Link>
          <Link
            _hover={{
              color: 'gray.500',
              transform: "scale(0.98)",
              transition: 'all .1s ease',
            }}
            _active={{
              color: 'gray.500',
              transform: "scale(0.96)",
              transition: 'all .1s ease',
            }}
            href='https://www.instagram.com/sharel.sj/' isExternal
            color={useColorModeValue('gray.900', 'white')}>
            {<IoLogoInstagram />}
          </Link>
          <Link
            _hover={{
              color: 'gray.500',
              transform: "scale(0.98)",
              transition: 'all .1s ease',
            }}
            _active={{
              color: 'gray.500',
              transform: "scale(0.96)",
              transition: 'all .1s ease',
            }}
            href='https://www.linkedin.com/in/sharelsj/' isExternal
            color={useColorModeValue('gray.900', 'white')}>
            {<FaLinkedinIn />}
          </Link>

        </HStack>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <Grid minH={'100vh'}>
          <Spacer />
          <MobileNav />
          <Spacer />
        </Grid>
      </Collapse>

    </Box>
  );
}

const MobileNav = () => {
  return (
    <VStack >
      <HStack direction={{ sm: 'row', md: 'row' }} px={{ sm: '0', md: '10' }}
      >
        <Spacer />
        <Stack
          py={4}
          px={{ sm: '0', md: 4 }}
          minW={{ sm: '318', md: '350px' }}
        // direction={{sm:'column', md:'row'}}
        // maxW={{sm:'100', md:'350px'}}
        >
          {NAV_ITEMS.map((navItem) => (
            <MobileNavItem pt={'200px'} key={navItem.label} {...navItem} />
          ))}
        </Stack>
        <Spacer />
        <Stack
          minW={{ base: '100px', md: '350px' }}
          textAlign='left'
        >

          <chakra.p
            pt={4}
            color={useColorModeValue('gray.400', 'gray.200')}
            fontWeight={'500'}
            fontSize={{ base: 'xs', md: 'sm' }}
          >Email</chakra.p>
          <chakra.p
            fontWeight={'normal'}
            fontSize={{base:'xs',md:'lg'}}
            lineHeight={'1.2'}
          >
            <Link href='mailto:sharel.liu@columbia.edu' isExternal>sharel.liu@columbia.edu</Link>
          </chakra.p>

          <chakra.p
            pt={4}
            // fontWeight={'light'}
            fontWeight={'500'}
            color={useColorModeValue('gray.400', 'gray.200')}
            fontSize={{ base: 'xs', md: 'sm' }}
          >Let's connect</chakra.p>
          <chakra.p
            fontWeight={'normal'}
            fontSize={{base:'xs',md:'lg'}}
            lineHeight={'1.5'}
          >
            <Link href='https://www.youtube.com/@sharelsj' isExternal>
              youtube.com/@sharelsj </Link>
            <br />
            <Link href='https://www.instagram.com/sharel.sj/' isExternal>
              instagram.com/sharel.sj </Link>
            <br />
            <Link href='https://www.linkedin.com/in/sharelsj/' isExternal>
              linkedin.com/in/sharelsj</Link>
          </chakra.p>

        </Stack>
        <Spacer />
      </HStack>
      <Spacer />
      {/* <Socials/> */}
    </VStack>
  );
};

const MobileNavItem = ({ label, children, href }: NavItem) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Flex
        // py={2}
        justify={'space-between'}
        align={'center'}
        _hover={{
          textDecoration: 'none',
        }}>
        <Link href={href}
          _hover={{
            textDecoration: 'none',
          }}>
            {/* "about" "projects" */}
          <Text
            fontWeight={200}
            // fontWeight={'thin'}
            fontSize={{ base: 'lg', md: '3xl' }}
            color={useColorModeValue('gray.600', 'gray.200')}>
            {label}
          </Text>
        </Link>
          {children && (
            <Icon
              as={ChevronDownIcon}
              transition={'all .25s ease-in-out'}
              transform={isOpen ? 'rotate(180deg)' : ''}
              w={4}
              h={4}
            />
          )}
      </Flex>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
        <Stack
          // mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          align={'start'}
          fontWeight={'400'}
          fontSize={{base:'xs',md:'lg'}}
          >
          {children &&
            children.map((child) => (
              <Link key={child.label} py={2} href={child.href}>
                {child.label}
              </Link>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};

interface NavItem {
  label: string;
  subLabel?: string;
  children?: Array<NavItem>;
  href?: string;
}

const NAV_ITEMS: Array<NavItem> = [
  {
    label: 'Architecture',
    children: [
      {
        label: '🏘️ City House Living',
        subLabel: 'GSAPP Core 3 Studio | F2023',
        href: '/#cityhouseliving',
      },
      {
        label: '🥕 Urban Agriscape',
        subLabel: 'GSAPP Tech 4 Studio | F2023',
        href: '/#urbanagriscape',
      },
      {
        label: '🌳 Bioregenerative Civic Center',
        subLabel: 'GSAPP Core 2 Studio | S2023',
        href: '/#bioregeneration',
      },
      {
        label: '⛰️ Recycled "Little Island"',
        subLabel: 'GSAPP ADR1 | F2022',
        href: '/#recycledlittleisland',
      },
      {
        label: '🖌️ Generative City Design',
        subLabel: 'GSAPP ADR2 | S2023',
        href: '/#generativecitydesign',
      },
    ],
  },
  // {
  //   label: 'Animations',
  //   href: '/#animations',
  // },
  {
    label: 'Renderings',
    href: '/#renderings',
  },
  {
    label: 'Hand Drawings',
    href: '/#handdrawings',
  },
  {
    label: 'About',
    children: [
      {
        label: 'GSAPP M.Arch | Columbia University',
        subLabel: '',
        href: 'https://www.arch.columbia.edu/student-work?student_name_contains=sharel+liu&title_code_callnumber_etc_contains=&faculty_name_contains=&program_area=&program=&by_course_sequence=&by_semester_year=ALL+SEMESTERS+%26+YEARS',
      },
      {
        label: 'Columbia College | Columbia University',
        subLabel: '',
        href: 'https://architecture.barnard.edu/sites/default/files/inline-files/TKTNK%202016_0.pdf',
      },
      {
        label: 'Choate Rosemary Hall',
        subLabel: '',
        href: 'https://www.choate.edu/',
      },
      {
        label: 'Chinese International School',
        subLabel: '',
        href: 'https://www.cis.edu.hk/',
      },
    ],
  },
  {
    label: 'Writing',
    children: [
      {
        label: 'Log 46 | Community on Tap',
        subLabel: '',
        href: 'https://www.jstor.org/stable/26759041',
      },
    ],
  },


];